import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";
import { Promotion, Quest } from "@quest_editor/mocks";

const PromotionInfoSection = ({
  quest,
  promotion,
  getTypeLabel,
  buildOptionsDisplay,
}: {
  quest: Quest;
  promotion: Promotion;
  getTypeLabel: (type: string) => string;
  buildOptionsDisplay: (promotion: Promotion | null | undefined) => string[];
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_start_review.section.promotion_info")}
      rows={[
        {
          label: t("quest_start_review.field.promotion_info.quest_id"),
          children: <Typography color="primary">{quest.id}</Typography>,
        },
        {
          label: t("quest_start_review.field.promotion_info.name"),
          children: <Typography color="primary">{promotion.name}</Typography>,
        },
        {
          label: t("quest_start_review.field.promotion_info.type"),
          children: (
            <Typography color="primary">
              {getTypeLabel(promotion.type)}
            </Typography>
          ),
        },
        {
          label: t("quest_start_review.field.promotion_info.description"),
          children: (
            <Typography color="primary" sx={{ whiteSpace: "pre-wrap" }}>
              {promotion.description}
            </Typography>
          ),
        },
        {
          label: t("quest_start_review.field.promotion_info.options"),
          children: (
            <Stack direction="column" spacing={0.5}>
              {buildOptionsDisplay(promotion).map(
                (option: string, index: number) => (
                  <Typography color="primary" key={index}>
                    {option}
                  </Typography>
                ),
              )}
            </Stack>
          ),
        },
      ]}
    />
  );
};

export default PromotionInfoSection;
